module.exports = __webpack_public_path__ + "static/media/IMG-5848.08084882.jpg";